module.exports = __webpack_public_path__ + "img/Tessellate22.90e8a7d4.jpg";